import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { LenderUserBorrowerPreferencesPut } from './lender-user-borrower-preferences.action';
import { catchError } from 'rxjs/operators';
import { of, tap } from 'rxjs';
import { LenderUserBorrowerPreference } from 'ng2-app/models/dto/lender-user-borrower-preference.model';
import { LenderUserBorrowerPreferenceService } from 'ng2-app/services/lender-user-borrower-preference/lender-user-borrower-preference.service';

export class LenderUserBorrowerPreferenceStateModel {
  loading: boolean;
  lenderUserBorrowerPreferences: LenderUserBorrowerPreference[];
}

@State<Partial<LenderUserBorrowerPreferenceStateModel>>({
  name: 'lenderUserBorrowerPreference',
  defaults: {
    lenderUserBorrowerPreferences: [],
    loading: false,
  }
})

@Injectable()
export class LenderUserBorrowerPreferencesState {

  @Selector()
  static loading(state: LenderUserBorrowerPreferenceStateModel) {
    return state?.loading ?? false;
  }

  constructor(
    private lenderUserBorrowerPreferencesService: LenderUserBorrowerPreferenceService,
  ) {}

  @Action(LenderUserBorrowerPreferencesPut)
  lenderUserBorrowerPreferencesPut(
    ctx: StateContext<LenderUserBorrowerPreferenceStateModel>,
    { borrowerId, favorite }: LenderUserBorrowerPreferencesPut) {
    ctx.patchState({loading: true});
    return this.lenderUserBorrowerPreferencesService.put(borrowerId, favorite).pipe(
      catchError(err => {
        ctx.patchState({loading: false});
        return of(err);
      }),
      tap( preferences => {
        ctx.patchState({
          loading: false,
        });
      })
    );
  }
}
